import { Colors } from 'baseStyles/enums/colors'
import React, { useState } from 'react'
import Box from 'schoolUiComponents/basic/Box'
import FlexBox from 'schoolUiComponents/basic/Box/FlexBox'
import { FlexProps } from 'schoolUiComponents/basic/Box/FlexBox/types'
import Button from 'schoolUiComponents/basic/Button'
import Checkbox, { CheckboxValue } from 'schoolUiComponents/basic/Checkbox'
import Divider from 'schoolUiComponents/basic/Divider'
import Text from 'schoolUiComponents/basic/Text'
import PopupViewer from 'schoolUiComponents/PopupViewer'
import { useTeacherSignupState } from '../../state'
import TeacherSignupStyles from '../../style'

const TermsAndConditionsPopup = () => {

    const themeStyles = TeacherSignupStyles();

    const { makeTeacherSignup, isTermsAndConditionsChecked, isNewsLetterChecked, toggleIsNewsLetterChecked, toggleIsTermsAndConditionsChecked, toggleTnCPopup } = useTeacherSignupState();

    const redirectToTermsOfUse = () => {
        window.open("/terms-of-use", "_blank");
    }

    const redirectToPrivacyPolicy = () => {
        window.open("/privacy", "_blank");
    }

    return (
        <PopupViewer closeCallback={() => toggleTnCPopup(false)} zIndex={99999}>
            <FlexBox column width={themeStyles.tncPopup.width}>
                <FlexBox fullWidth center><Text.H3>To Continue with SplashLearn</Text.H3></FlexBox>

                <Divider marginTop={9} marginBottom={30} />
                
                <FlexBox fullWidth center><Text center>Please agree on below Terms & Privacy Policy</Text></FlexBox>

                <FlexBox justifyContent={themeStyles?.tncPopup?.justifyContent} flexWrap={FlexProps.FlexWrap.NOWRAP} fullWidth alignItems={FlexProps.AlignItems.CENTER} gap={16} margin={`24px 0 0 0`}>
                    <Checkbox checked={isTermsAndConditionsChecked ? CheckboxValue.CHECKED : CheckboxValue.UNCHECKED} onClick={() => toggleIsTermsAndConditionsChecked(isTermsAndConditionsChecked ? false : true)} />
                    <FlexBox>
                        <Text color={Colors.PURE_RED}>*</Text>
                        <Text.SMALL>I agree to SplashLearn's&nbsp;</Text.SMALL>
                        <Box onClick={redirectToTermsOfUse}><Text.SMALL cta emphasis>Terms and Conditions</Text.SMALL></Box>
                        <Text.SMALL>&nbsp;and&nbsp;</Text.SMALL>
                        <Box onClick={redirectToPrivacyPolicy}><Text.SMALL cta emphasis>Privacy Policy</Text.SMALL></Box>
                    </FlexBox> 
                </FlexBox>

                <FlexBox flexWrap={FlexProps.FlexWrap.NOWRAP} margin={`24px 0`} fullWidth height={12} justifyContent={FlexProps.JustifyContent.CENTER} alignItems={FlexProps.AlignItems.CENTER} gap={24}>
                    <Box width={`30%`} height={1} backgroundColor={Colors.LIGHT_GREY_1}></Box>
                    <Box><Text.H4 letterSpacing={0.28} color={Colors.LIGHT_GREY_1}>&nbsp;Email Preferences&nbsp;</Text.H4></Box>
                    <Box width={`30%`} height={1} backgroundColor={Colors.LIGHT_GREY_1}></Box>
                </FlexBox>

                <FlexBox justifyContent={themeStyles?.tncPopup?.justifyContent} flexWrap={FlexProps.FlexWrap.NOWRAP} fullWidth alignItems={FlexProps.AlignItems.CENTER} gap={24}>
                    <Checkbox checked={isNewsLetterChecked ? CheckboxValue.CHECKED : CheckboxValue.UNCHECKED} onClick={() => toggleIsNewsLetterChecked(isNewsLetterChecked ? false : true)} />
                    <FlexBox width={`73%`}>
                        <Text.SMALL lines={4}>I want to receive newsletters, offers & learning resources from SplashLearn. (You can unsubscribe anytime)</Text.SMALL>
                    </FlexBox>
                </FlexBox>

                <FlexBox width={300} className='simple-input-box' margin={`24px 0 0 0`}>
                    <Button
                        primary
                        height="36px"
                        onClick={() => makeTeacherSignup()}
                        dataTestId="sign-up-btn"
                        name="commit"
                        id="submit_1"
                        disabled={!isTermsAndConditionsChecked}
                    >
                        <Text.H4 color={Colors.WHITE}>
                            Proceed
                        </Text.H4>
                    </Button>
                </FlexBox>

                <FlexBox fullWidth center margin={`10px 0 0 0`}>
                    <Text.FOOTER color={Colors.LIGHT_GREY_1}>For any query, contact us on help@splashlearn.com</Text.FOOTER>
                </FlexBox>
            </FlexBox>
        </PopupViewer>
    )
}

export default TermsAndConditionsPopup